import { api } from "./api";

export const packingTypeApi = (params) => {
  return api.get("/manufacturer/product/packing-type", JSON.stringify(params));
};

export const productListApi = (params) => {
  return api.get("/manufacturer/product/products-list", { params: params });
};

export const productDetailApi = (params) => {
  return api.get("/manufacturer/product/product-view", { params: params });
};

export const productCreateApi = (params) => {
  return api.post(
    `/manufacturer/product/product-create`,
    JSON.stringify(params)
  );
};

export const productEditApi = (params) => {
  return api.post(`/manufacturer/product/product-edit`, JSON.stringify(params));
};

export const productEnableDisale = (params) => {
  return api.post(
    `/manufacturer/product/product-disableEnable`,
    JSON.stringify(params)
  );
};

export const productDeleteApi = (params) => {
  return api.delete(`/manufacturer/product/product-delete`, { data: params });
};

export const productVersionList = (params) => {
  return api.get(`manufacturer/product/products-version-list`, {
    params: params,
  });
};

export const productViewDoctorList = (params) => {
  return api.get(`/manufacturer/product/product-offer-doctor-list`, {
    params,
  });
};
export const productViewPharmacyList = (params) => {
  return api.get(`/manufacturer/product/product-offer-pharmacy-list`, {
    params,
  });
};
export const productDoctorOfferRequest = (params) => {
  return api.post(
    `/manufacturer/product/product-offer-doctor-update`,
    JSON.stringify(params)
  );
};
export const productPharmacyOfferRequest = (params) => {
  return api.post(
    `/manufacturer/product/product-offer-pharmacy-update`,
    JSON.stringify(params)
  );
};

export const productVersionDetail = (params) => {
  return api.get(`/manufacturer/product/product-version-view`, {
    params: params,
  });
};
export const vendorDivisionListApi = (params) => {
  return api.get(
    "/manufacturer/product/vendor-division-list",
    JSON.stringify(params)
  );
};

export const headQuaterListApi = () => {
  return api.get("/manufacturer/product/head-quater/list");
};

export const productDoctorListApi = (params) => {
  return api.get("/manufacturer/product/doctors/list", { params: params });
};
export const productPharmacyListApi = (params) => {
  return api.get("/manufacturer/product/pharmacy/list", { params: params });
};
export const productAddDoctorListApi = (params) => {
  return api.get("/manufacturer/product/doctors/list");
};
export const productAddPharmacyListApi = (params) => {
  return api.get("/manufacturer/product/pharmacy/list");
};
export const productDoctorAdd = (params) => {
  return api.post(
    `/manufacturer/product/product-offer-doctor-add`,
    JSON.stringify(params)
  );
};
export const productPharmacyAdd = (params) => {
  return api.post(
    `/manufacturer/product/product-offer-pharmacy-add`,
    JSON.stringify(params)
  );
};
